import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CmpsActivityStatusWrapperComponent } from './activity-status-wrapper.component';

@NgModule({
    declarations: [CmpsActivityStatusWrapperComponent],
    imports: [CommonModule],
    exports: [CmpsActivityStatusWrapperComponent],
})
export class CmpsActivityStatusWrapperModule {}
